import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const PageStack = styled(motion.div, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
})

const Header = styled(motion.div, {
  base: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '12px',
    paddingX: '4px',
    paddingY: '8px',
  },
})

const HeaderLeft = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
})

const PageTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '32px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.5px',
  },
})

const PageSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '16px',
    color: 'quickpass.inkSoft',
    margin: '0',
  },
})

const SectionCard = styled(motion.section, {
  base: {
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '24px',
    boxShadow: '0 12px 32px -16px rgba(128, 84, 255, 0.12)',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
})

const SectionTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '20px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.3px',
  },
})

const SectionGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '16px',
  },
})

const InlineFieldRow = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '12px',
  },
})

const FormActions = styled(motion.div, {
  base: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    paddingTop: '8px',
  },
})

const ErrorBanner = styled(motion.div, {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.warmth',
    padding: '10px 14px',
    borderRadius: 'sm',
  },
})

const SuccessBanner = styled(motion.div, {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.ink',
    backgroundColor: 'quickpass.success',
    padding: '10px 14px',
    borderRadius: 'sm',
  },
})

const PreferenceCell = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
})

const PreferenceLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
})

const PreferenceValue = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

export {
  PageStack,
  Header,
  HeaderLeft,
  PageTitle,
  PageSubtitle,
  SectionCard,
  SectionTitle,
  SectionGrid,
  InlineFieldRow,
  FormActions,
  ErrorBanner,
  SuccessBanner,
  PreferenceCell,
  PreferenceLabel,
  PreferenceValue,
}
